import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { Col, Row, Container, FormGroup } from "reactstrap";
import * as url from '../../../utils/url';
import findIndex from 'lodash/findIndex';
import axios from '../../../axios';
import {saveAs} from 'file-saver';
import { toolkitCategories } from '../../../utils/categories';
import {getCountries} from '../../../utils/countries';
import {getStatesByCountryCode} from '../../../utils/states';
import DetailsSection from "../../toolkit/ToolDetails/Sections/DetailsSection/DetailsSection";
import MoreSection from "../../toolkit/ToolDetails/Sections/MoreSection/MoreSection";
import HeaderSection from "../../toolkit/ToolDetails/Sections/HeaderSection/HeaderSection";
import ContactModal from '../../toolkit/ToolDetails/Details/ContactModal';
// import Loading from '../../../../hoc/Loading/Loading';
// import { canEditTool } from "../../../../utils/privacySettings";
import html2canvas from 'html2canvas';
import ExportableTool from "../../toolkit/ToolDetails/Details/ExportableTool";
import moment from "moment";
import EventsMap from "../../../components/AddressSearch/EventsMap";


class PublicTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toolDetails: {},
      allComments : [],
      displayComments : [],
      commentPage : 0,
      isExporting : false,
      showContactModal : false,
      orgUserList: []
    }
    this.toolDetailRef = null;
  }

  componentWillMount() {
  }

  componentDidMount = () => {
    let id = this.props.match.params.id; 
    this.getToolDetails(id);
  }

  componentWillReceiveProps(nextProps) {
    const category = this.props.match.params.category;
    let {toolDetails} = nextProps;
    if(toolDetails && toolDetails.redirectionPath && toolDetails.redirectionPath.startsWith(`/home/toolkit/${category}/edit/`)) {
      this.props.history.push(toolDetails.redirectionPath);
    }
  }

  toggleContactModal = () => {this.setState((prev) => ({showContactModal : !prev.showContactModal}))}

  handleExportClick = () => {
    let node = ReactDOM.findDOMNode(this.toolDetailRef);
    this.setState({isExporting : true});
    html2canvas(node).then((canvas) => {
      canvas.toBlob((blob) => { 
        this.setState({isExporting : false});
        saveAs(blob,"tooldetail.png"); 
      });
    });
  }



  // Get organization user list to show it on share modal
  getToolDetails(id) {
    axios.get(url.getPublicTool(id))
    .then((response) => {
      // console.log(response)
      let toolDetails = response.data.data;
      let diversityFocus = toolDetails.categoryTypes["1"];
      let relevantFor = toolDetails.categoryTypes["2"];
      toolDetails.diversityFocus = [];
      toolDetails.relevantFor = [];
      if(diversityFocus && diversityFocus.length > 0) {
        toolDetails.diversityFocus = diversityFocus.map(selectedFocus => {
        return {key: selectedFocus._id, focus: selectedFocus.focus}});
      }
      if(relevantFor && relevantFor.length > 0) {
        toolDetails.relevantFor = relevantFor.map(selectedFocus => {
          return {key: selectedFocus._id, focus: selectedFocus.focus}});
      }
      delete toolDetails.categoryTypes;
      if(toolDetails.toolkitTags && toolDetails.toolkitTags.relevantForTags && toolDetails.toolkitTags.relevantForTags.length>0) {
        toolDetails.relevantForTags = toolDetails.toolkitTags.relevantForTags.toString();
        toolDetails.relevantFor.push({key: 'otherRelevantFor', focus: 'Other', type: 'relevantForTag'});
      }
      if(toolDetails.toolkitTags && toolDetails.toolkitTags.diversityFocusTags && toolDetails.toolkitTags.diversityFocusTags.length>0) {
        toolDetails.diversityFocusTags = toolDetails.toolkitTags.diversityFocusTags.toString();
        toolDetails.diversityFocus.push({key: 'otherDiversityFocus', focus: 'Other', type: 'diversityFocusTag'});
      }

      if(toolDetails.subCategory && toolDetails.subCategory!=='' && toolDetails.subCategory!==null) {
        toolDetails.subCategory = {subCategoryKey: toolDetails.subCategory, subCategoryValue: toolDetails.subCategory};
      }

      if(toolDetails.locations && toolDetails.locations.length>0) {
        let states = [];
        let allCountries = getCountries();
        let allState = getStatesByCountryCode('US');
        let selectedCountries = toolDetails.locations.map(location => location.country);
        let selectedStates = toolDetails.locations.map(location => location.states);
        selectedStates = selectedStates.filter(states => states.length > 0);
        let countries = allCountries.filter(country => selectedCountries.indexOf(country.name)!==-1);
        if(selectedStates.length>0) {
           states = allState.filter(state => selectedStates[0].indexOf(state.name)!==-1);
        }
        toolDetails['selectedLocations'] ={countries,states};
     } else {
        toolDetails['selectedLocations'] ={countries: [],states: []};
     }

      delete toolDetails.toolkitTags;

      
      if(!toolDetails.ratings){
        toolDetails['ratings'] = [];
      }
      this.setState({
        toolDetails: toolDetails
      })
    })
    .catch((error) => {
      console.log(error);
    })
  }

  checkContactInfo=(tool)=>{
    let{address,contactName,contactEmailID,contactPhone,website}=tool
    
    if(address||contactName||contactEmailID||contactPhone||website){
      return true
    } else {
      return false
    }
  
  }

  render() {
    let detailsSection =null;
    let moreSection =null;
    let headerSection =null;
    const {isExporting,showContactModal,toolDetails} = this.state;
    // console.log(this.state.toolDetails)
    if(this.state && toolDetails && toolDetails.category) {
      detailsSection = <DetailsSection {...this.state} />;
      moreSection = 
      <MoreSection  
        onExportClick={this.handleExportClick} 
        // onContactClick={this.toggleContactModal}
        hideContact={true}
        fromPublicTool
        {...this.state} />;
      headerSection = <HeaderSection {...this.state} onAddRatingClick={this.toggleRatingModal} user={this.props.user} hideRatingsSection/>; 
    } 
    return (
      <Container className="mt60">
        <Row>
        <Col sm={{size: 10 , offset: 1}}>
          <Row className="mt30">
            {headerSection}
          </Row>
          <Row className="mt30">
            <Col sm={8} >
            {detailsSection}
            </Col>
            <Col sm={4} className="pr0">
            <div>{moreSection}</div>
            </Col>
            <div className="container">
            {this.checkContactInfo(toolDetails)?
            <div>
            <FormGroup className="details-title mb25" row>Contact</FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Address</Col>
              <Col className="details-sub-value text-left">{toolDetails.address}</Col> 
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Name</Col>
              <Col className="details-sub-value text-left">{toolDetails.contactName}</Col> 
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Email</Col>
              <Col className="details-sub-value text-left">{toolDetails.contactEmailID}</Col> 
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Phone</Col>
              <Col className="details-sub-value text-left">{toolDetails.contactPhone}</Col> 
            </FormGroup>
            <FormGroup className="" row>
              <Col className="details-sub-title text-left pl0">Website</Col>
              <Col className="details-sub-value text-left">{toolDetails.website}</Col> 
            </FormGroup>
            </div>
           :
           <span className="noContactInfo">No contact info provided.</span>
           }

          <EventsMap
             item={toolDetails}
          />
        </div>
          </Row>   
        </Col>
        {/* <ContactModal
          showModal={showContactModal}
          toggle={this.toggleContactModal}
          toolDetails={toolDetails}
        /> */}
        {isExporting?
        
        <ExportableTool
          isExporting={isExporting}
          ref={(ref) => this.toolDetailRef = ref}
          toolDetails={toolDetails}
          user={this.props.user? this.props.user:""}
        />
        :
        null}
        </Row>
      </Container>
    );
  }
}

export default PublicTool;
